import React from "react"
import PropTypes from "prop-types"

import OneTimeChoice from './OneTimeChoice'
import MembershipChoices from './MembershipChoices'
import MembershipCheckout from './checkout/MembershipCheckout';
import OneTimeCheckout from './checkout/OneTimeCheckout';
import moment from 'moment'

class Pricing extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      smallColor: 'blue',
      largeColor: 'blue',
      selectedTab: '',
      current_membership: '',
      free_membership: '',
      current_user: {},
      checkoutOpen: false,
      selectedPlan: '',
      selectedItem: '',
      stripePublishableKey: ''
    }

    this.onClick = this.onClick.bind(this)
    this.selectedStyle = this.selectedStyle.bind(this)
    this.subTitle = this.subTitle.bind(this)
    this.renewalText = this.renewalText.bind(this)
    this.legacyPlanPrice = this.legacyPlanPrice.bind(this)
    this.nextPaymentDate = this.nextPaymentDate.bind(this)
    this.cancelDate = this.cancelDate.bind(this)
    this.setUser = this.setUser.bind(this)
    this.cancelMembership = this.cancelMembership.bind(this)
    this.openMembershipCheckout = this.openMembershipCheckout.bind(this)
    this.openOneTimeCheckout = this.openOneTimeCheckout.bind(this)
    this.closeCheckout = this.closeCheckout.bind(this)
    this.getSubscription = this.getSubscription.bind(this)
    this.getStripePublishableKey = this.getStripePublishableKey.bind(this)
  }

  cancelMembership() {

      $.ajax({
        url: `/cancelSubscription`,
        dataType: 'JSONP',
        type: 'GET',
        success: function(data) {
          this.getSubscription()
        }.bind(this),
        error: function(xhr, status, err) {

        }.bind(this)
      })

  }

  setUser() {
    if(this.state.current_user === null) {
      return
    } else if(this.state.current_user != null && this.state.subscription != null  && this.state.subscription.plan_id != null) {
      if(this.state.subscription.plan_id === 1 || this.state.subscription.plan_id === 3 || this.state.subscription.plan_id === 5) {
        this.setState({
          current_membership: "Pro",
          free_membership: false
        })
      } else if (this.state.subscription.plan_id === 2 || this.state.subscription.plan_id === 4 || this.state.subscription.plan_id === 6) {
        this.setState({
          current_membership: "Elite",
          free_membership: false
        })
      }
    } else if (this.state.current_user.premium || this.state.current_user.basic_forever) {
      this.setState({
        current_membership: 'Pro',
        free_membership: true
      })
    }
  }

  getSubscription() {
    $.ajax({
      url: `${window.location.origin}/get_subscription`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          current_user: JSON.parse(data.data.current_user),
          subscription: JSON.parse(data.data.subscription),
          id_verification: JSON.parse(data.data.id_verification),
        }, () => this.setUser())
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  getStripePublishableKey() {
    $.ajax({
      url: `../getStripePublishableKey`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          stripePublishableKey: data.key,
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  async componentDidMount() {
    await this.getSubscription()
    if(this.props.oneTime === 'true') {
      this.setState({
        selectedTab: 2
      })
    } else {
      this.setState({
        selectedTab: 1
      })
    }

    await this.getStripePublishableKey()



  }

  onClick(selectedTab) {
    this.setState({
      selectedTab: selectedTab
    })
  }

  subTitle() {
    if(this.state.selectedTab === 1) {
      if(this.state.current_membership != '') {
        return `Current Membership: ${this.state.current_membership}`
      }
      return 'Match. Meet. Immerse!'
    } else if (this.state.selectedTab === 2) {
      return 'Not ready to commit?'
    }
  }

  legacyPlanPrice() {
    if(this.state.subscription.plan_id === 1) {
      return "$5/month"
    } else if (this.state.subscription.plan_id === 2) {
      return "$29/year"
    } else if (this.state.subscription.plan_id === 3) {
      return "$2/month"
    } else if (this.state.subscription.plan_id === 4) {
      return "$19/year"
    } else if (this.state.subscription.plan_id === 5) {
      return "$7/month"
    } else if (this.state.subscription.plan_id === 6) {
      return "$39/year"
    }
    return null
  }

  nextPaymentDate() {
      if(this.state.subscription.plan_id === 1 || this.state.subscription.plan_id === 3 || this.state.subscription.plan_id === 5) {

        let this_month = moment().format('M')
        let next_month = moment().add(1, 'month').format('M')
        let renewalDate = moment(this.state.subscription.updated_at).format('D')
        let todayDate = moment().format('D')
        let renewThisMonth = (todayDate <= renewalDate)
        if(!renewThisMonth) {
          return `${this_month}/${renewalDate}`
        }
        return `${next_month}/${renewalDate}`
      } else if (this.state.subscription.plan_id === 2 || this.state.subscription.plan_id === 4 || this.state.subscription.plan_id === 6) {
        let today = moment().format('M/D')
        let renewalDate = moment(this.state.subscription.updated_at).format('M/D')
        let thisYear = moment().format('YYYY')
        let nextYear = moment().add(1, 'year').format('YYYY')
        let renewThisYear = moment(today).isBefore(renewalDate)
        if(renewThisYear) {
          return `${renewalDate}/${thisYear}`
        }
        return `${renewalDate}/${nextYear}`
      }
  }

  cancelDate() {
        let today = moment().format('M/D')
        let renewalDate = moment(this.state.subscription.cancel_date).format('M/D')
        let thisYear = moment().format('YYYY')
        let nextYear = moment().add(1, 'year').format('YYYY')
        let renewThisYear = moment(today).isBefore(renewalDate)
        if(renewThisYear) {
          return `${renewalDate}/${thisYear}`
        }
        return `${renewalDate}/${nextYear}`
  }

  renewalText() {
    if(this.state.free_membership) {
      return(
        <div style={{marginTop: 5}}>
          <p className="darkBlue">Thanks for being an early member of Lexody!</p>
          <p style={{color: 'white'}}>You have a free Pro membership until 12/31/2020!</p>
        </div>
      )
    } else if (this.state.subscription != null && this.state.subscription.plan_id != null) {
      if(this.state.subscription.cancel_date != null) {
        return(
          <div style={{marginTop: 5}}>
            <h6 className="darkBlue">Pro membership ends: {this.cancelDate()}</h6>
          </div>
        )
      } else if(this.state.subscription.plan_id < 5) {
        return(
          <div style={{marginTop: 5}}>
            <h6 className="darkBlue" >Thanks for being an early member of Lexody!</h6>
            <h6 style={{color: 'white'}}>You have a legacy {this.state.current_membership} membership - {this.legacyPlanPrice()}</h6>
            <h6 className="darkBlue">next automatic payment: {this.nextPaymentDate()}</h6>
          </div>
        )
      } else {
        return(
          <div style={{marginTop: 5}}>
            <h6 className="darkBlue">next automatic payment: {this.nextPaymentDate()}</h6>
          </div>
        )
      }

    }
    return null
  }

  selectedStyle(tabNumber) {
    if(this.state.selectedTab === tabNumber) {
      return(
        {
          color: '#0D0E10',
          borderBottom: '1px solid #03A9F4',
          padding: 12,
          paddingRight: 10,
          paddingLeft: 10,
          fontSize: 14,
          fontWeight: 'bold'
        }
      )
    } else {
      return(
        {
          color: '#979797',
          padding: 12,
          paddingRight: 10,
          paddingLeft: 10,
          fontSize: 14
        }
      )
    }
  }

  closeCheckout() {
    this.getSubscription()
    this.setState({
      selectedPlan: '',
      selectedItem: '',
      checkoutOpen: false
    })
  }

  openMembershipCheckout(plan_id) {
    this.setState({
      selectedPlan: plan_id,
      selectedItem: '',
      checkoutOpen: true
    })
  }

  openOneTimeCheckout(item_id) {
    this.setState({
      selectedPlan: '',
      selectedItem: item_id,
      checkoutOpen: true
    })
  }

  renderCancelMembership() {
    if(this.state.subscription.cancel_date === null) {
      return(<h5 style={{fontWeight: 600, cursor: 'pointer', marginTop: 15}} className="red" onClick={() => this.cancelMembership()}>Cancel Paid Membership</h5>)
    }
    else return (<h5 style={{fontWeight: 600, marginTop: 15}} className="red">Your Paid Membership will cancel at the end of the period.</h5>)
  }

  render() {
      if(this.state.checkoutOpen) {
        if(this.state.selectedTab === 1) {
          return(
            <MembershipCheckout
              plan_id={this.state.selectedPlan}
              closeCheckout={this.closeCheckout}
              stripePublishableKey={this.state.stripePublishableKey}
            />
          )
        }
        return(
          <OneTimeCheckout
            item_id={this.state.selectedItem}
            closeCheckout={this.closeCheckout}
            stripePublishableKey={this.state.stripePublishableKey}
          />
        )
      }
      return (
        <div id="free_pricing" style={{marginTop: 20}}>
          <h1 className="darkBlue" style={{fontWeight: 700}}>More features, more Lexes, more immersion!</h1>

          <h3 className="darkBlue" style={{marginTop: 10}}>{this.subTitle()}</h3>
          {this.state.selectedTab === 1 && this.renewalText()}
          <div style={{width: 310, margin: 'auto', cursor:'pointer', marginBottom: 40, marginTop: 20, cursor: 'pointer', alignItems: 'center', display: 'flex', justifyContent: 'space-between'}}>
            <a onClick={() => this.onClick(1)} style={this.selectedStyle(1)}>Membership</a>
            <a onClick={() => this.onClick(2)} style={this.selectedStyle(2)}>Lexicoins</a>
            <a onClick={() => this.onClick(3)} style={this.selectedStyle(3)}>Verify ID</a>
          </div>
          <div style={{
            justifyContent: 'space-around'
          }}>
            {(this.state.selectedTab === 1) &&
              <MembershipChoices
                subscription={this.state.subscription}
                current_user={this.state.current_user}
                openCheckout={this.openMembershipCheckout}
                cancelMembership={this.cancelMembership}
              />}
            {(this.state.selectedTab > 1) &&
              <OneTimeChoice
                tab={this.state.selectedTab}
                current_user={this.state.current_user}
                subscription={this.state.subscription}
                id_verification={this.state.id_verification}
                openCheckout={this.openOneTimeCheckout}
                />}
            {(this.state.selectedTab === 1) && <h5 className="darkBlue" style={{marginTop: 20}}>* The Pro plans allow you to <span className="pink">verifiy your identity</span> for a one-time fee of $10.</h5>}
            {(this.state.selectedTab === 1 && this.state.current_membership != '') && this.renderCancelMembership()}

          </div>
        </div>
      )
  }
}

export default Pricing
